/* eslint-disable */
import React, { Fragment, Dispatch, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CancelIcon from '@material-ui/icons/Cancel';
import './RejectDialog.css';
import './DeactivateDailog.css';
import { onBoardingService } from '../../services/onBoarding.service';
import { onboardingService } from '../../services/onboard.service';
import { useHistory } from 'react-router-dom';
import { Dialog } from '@material-ui/core';
import { get } from 'lodash';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    title: {
        flex: '1 1 100%',
    },
    closeButton: {
        backgroundColor: '#EAEAEA',
        width: 80,
        fontWeight: 800,
        textTransform: 'capitalize',
        fontFamily: 'Nunito',
        fontSize: '0.688rem',
        color: '#666666',
        borderRadius: '2.5rem',
        height: 35,
        textAlign: 'center',
        marginRight: 24
    },
    icon: {
        float: "left",
        margin: "0 20px 20px 0",
        height: "100%",
        fill: "white",
    },
    cancel: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#919191',
        textTransform: 'capitalize'
    },
    deactivateText: {
        color: '#616161',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'inherit'
    }

}));

export default function DeactivateDialog(props: any) {
    const dispatch: Dispatch<any> = useDispatch();
    const classes = useStyles();
    const [deactivationMessage, setdeactivationMessage] = React.useState<any>('');
    const [deactivateTextErrorMessage, setdeactivateTextErrorMessage] = React.useState<boolean>(false);
    const history = useHistory()
    const { selectedNewDealer }: any = useSelector((state: any) => state.dealer);
    // const b2bUserId = get(selectedNewDealer, "createdByB2bUserId", "");
    const [deactivationMessageError, setdeactivationMessageError] = React.useState<boolean>(false);
    const [deactivationErrorMessage, setdeactivationErrorMessage] = React.useState<string>("");
    const [submitclassName, setSubmitclassName] = React.useState<string>("");

    const [openSnackbar, setOpenSnackbar] = React.useState(false);

    const [successMessage, setSuccessMessage] = React.useState<any>(null);
    const { openRequestSnackbar, setOpendeactivateDialog, status, message } = props;

    const b2bUserId: any = selectedNewDealer && selectedNewDealer.createdByB2bUserId;
    const sapCustomerId: any = selectedNewDealer && selectedNewDealer.sapCustomerId;

    const [selected, setSelected] = React.useState<any>('');
    const [docExpiryAutoDeactivate, setDocExpiryAutoDeactivate] = React.useState<any>(null)
    const isStatusPlusComing = sessionStorage.getItem('isStatusPlusComing');
    const statusPlus = sessionStorage.getItem('statusPlus');

    useEffect(() => {
        if (props.message) {
            setdeactivationMessage(props.message)
        }
        if (props.status == "Deactive") {
            setSubmitclassName("submit-activate-button");
        }
        else if (props.status === "Active" && isStatusPlusComing === "true") {
            setSubmitclassName("submit-activate-button");
        }
        else if (props.status === "Active" && isStatusPlusComing === "false") {
            setSubmitclassName("submit-deactivate-button");
        }
        else if (props.status == "Document expiry issue") {
            setSubmitclassName("submit-activate-button");
        }
        // if(props.dealerStatus=="Deactive"){}
    }, [status])

    // VALIDATION FOR MESSAGE

    // function validation(data: any) {
    //     const re = /^[a-z0-9 ]+$/i;
    //     return !re.test(data) ? false : true;
    // }

    // // ONCHANGE OF TEXTAREA-AUTOSIZE 
    // const handleCustomerChange = (e: any) => {
    //     setdeactivationMessage(e.target.value);
    //     if (e.target.value) {
    //         if (e.target.value === "" || e.target.value.trim() === "") {
    //             setdeactivationErrorMessage("");
    //             setdeactivationMessageError(true);
    //         }
    //         else if (e.target.value.length > 500) {
    //             setdeactivationErrorMessage("It should not exceed 500 characters");
    //             setdeactivationMessageError(true);
    //         }
    //         else if (!validation(e.target.value)) {
    //             setdeactivationErrorMessage("It should not allowed special characters");
    //             setdeactivationMessageError(true);
    //         }
    //         else {
    //             setdeactivationMessageError(false);

    //         }
    //     }
    //     else {
    //         setdeactivationErrorMessage("");
    //     }

    // }

    // ONCHANGE OF TEXTAREA-AUTOSIZE 
    const handleCustomerChange = (e: any) => {
        setdeactivationMessage(e.target.value);
        if (e.target.required) {
            if (e.target.value === "" || e.target.value.trim() === "") {
                setdeactivationMessageError(true);
            }
            else {
                setdeactivationMessageError(false);
            }
        }
    }

    const handleChange = (event: any) => {
        setSelected(event.target.value);
        if (event.target.value === "activate") {
            setDocExpiryAutoDeactivate(false);
        } else if (event.target.value === "deactivate") {
            setDocExpiryAutoDeactivate(true);
        }
    };

    // VALIDATION FOR TEXTAREA OF DEACTIVATE MESSAGE 
    function validatedeactivateMessage() {
        let isValid: boolean = true;
        if (props.status == "Active" && isStatusPlusComing === "false") {
            if (!deactivationMessage || deactivationMessage.trim() == "") {
                setdeactivationMessageError(true);
                setdeactivationErrorMessage("please enter deactivate message");
                isValid = false;
                return
            } else {
                if (deactivationMessage.split('').length > 500) {
                    setdeactivationMessageError(false);
                    setdeactivateTextErrorMessage(true);
                    isValid = false;
                    return
                }
                else {
                    setdeactivationMessageError(false);
                    setdeactivateTextErrorMessage(false);
                }
            }
        }
        // if(props.status == "Active" && isStatusPlusComing === "true") {
        //     deactivateMessageAPI();
        //     props.handleopenCloseSnackbar(true);
        //     setSuccessMessage('Customer Activated successfully');
        //     setdeactivationMessage(null);
        // }
        if (isValid) {
            deactivateMessageAPI();
            setdeactivationMessage(null);
        }
    }

    // // FOR DEACTIVATE MESSAGE API
    const deactivateMessageAPI = async () => {
        let action = ""
        if (props.status == "Deactive") {
            action = "active"
        }
        else if (props.status == "Active" && isStatusPlusComing === "true") {
            action = "active"
        }
        else if (props.status == "Active" && isStatusPlusComing === "false") {
            action = "deactive"
        } else if (props.status == "Document expiry issue") {
            action = docExpiryAutoDeactivate === false ? "active" : "active"
        }
        let payload = {
            "action": action,
            "deactivationReason": docExpiryAutoDeactivate === false ? deactivationMessage : docExpiryAutoDeactivate === true ? "Document expiry issue" : deactivationMessage,
            "docExpiryAutoDeactivate": docExpiryAutoDeactivate,
            "actionTakenBy": sessionStorage.getItem('webApplicationLoginId'),
        }
        let crStatus: any = await onboardingService.deactivateDealer(payload, sapCustomerId)
        // setOpenSnackbar(true)
        // setSuccessMessage(crStatus.message.message);
        if (crStatus.message.status == "S") {
            props.handleopenCloseSnackbar(true);
            setSuccessMessage(crStatus.message.message);
            setSelected("");
            setTimeout(() => {
                history.push('/dealers')
                props.handleopenClose(false);
            }, 2000)
        } else {
            setOpenSnackbar(false)
            setSuccessMessage(crStatus.message.message);
            props.handleopenClose(false);
        }
    }

    return (
        <Fragment>
            <Dialog
                open={props.open ? true : false}
                onClose={() => { props.handleopenClose(false); props.handleopenCloseSnackbar(false); setSelected(null); }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >
                <Snackbar
                    open={props.openRequestSnackbar ? true : false}
                    handleopenClose={() => { props.handleopenCloseSnackbar(false); setdeactivationMessage(null); }} message={successMessage}
                />
                <DialogContent>
                    <div className={classes.root}>
                        {
                            props.status == "Active" && isStatusPlusComing === "false" ?
                                <div className="col-12 mt-0">
                                    <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                                        <h4 className="shift-to-party-page-title px-3">
                                            <IconButton aria-label="close" className="float-right pr-4 mt-2"
                                                onClick={() => { props.handleopenClose(false); setdeactivateTextErrorMessage(false); setdeactivationMessageError(false); props.handleopenCloseSnackbar(false); setdeactivationMessage(null); setSelected(null); }}>
                                                <CloseIcon />
                                            </IconButton>
                                        </h4>
                                    </Typography>
                                </div> : ""}
                        {/* {
                            props.status == "Document expiry issue" ?
                                <div className="col-12 mt-0">
                                    <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                                        <h4 className="shift-to-party-page-title px-3">
                                            <IconButton aria-label="close" className="float-right pr-4 mt-2"
                                                onClick={() => { props.handleopenClose(false); setdeactivateTextErrorMessage(false); setdeactivationMessageError(false); props.handleopenCloseSnackbar(false); setdeactivationMessage(null); setSelected(null); }}>
                                                <CloseIcon />
                                            </IconButton>
                                        </h4>
                                    </Typography>
                                </div> : ""} */}
                        <DialogContent>
                            {
                                props.status == "Active" && isStatusPlusComing === "false" ?
                                    <div className={classes.icon}>
                                        <CancelIcon className="deactivate-meesage-warning" fontSize="small" />
                                    </div>
                                    : ""}
                            <div>
                                <DialogContentText id="alert-dialog-description">
                                    <div className={`mt-3 ${classes.deactivateText}`}>
                                        <h6 className="mb-0 fontweight-superadmin px-2 mb-3">{props.status === "Document expiry issue" ? "Are you sure to activate ?" : props.status == "Deactive" ? "Are you sure to activate ?" : "Are you sure to deactivate ?"}</h6>
                                    </div>
                                </DialogContentText>
                            </div>
                        </DialogContent>
                    </div>
                    {props.status == "Document expiry issue" || props.status == "Deactive" || props.status == "Active" && props.blockIntent === true ?
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 p-0">
                            <div className="col-12 border-top w-100 p-0">
                                <div className=' justify-content-around' id="demo-radio-buttons-group-label">
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue="BANK"
                                        name="radio-buttons-group"
                                        onChange={handleChange} value={selected}
                                    >
                                        <div className="row">
                                            <div className={"col"}>
                                                <FormControlLabel className={"col font-size-15 mx-2"}
                                                    value="activate" control={<Radio color="primary" />}
                                                    label="Activate" />
                                            </div>
                                            <Tooltip title="To be used in case of Document issues" placement="top">
                                                <div className={"col"}>
                                                    <FormControlLabel className={"col font-size-15 pr-2"}
                                                        disabled={statusPlus && statusPlus === "Manual" ? true : statusPlus && statusPlus === "T&C" ? true : statusPlus && statusPlus === "Doc" ? false : statusPlus && statusPlus === "Manual,T&C" ? true : statusPlus && statusPlus === "Manual,Doc" ? false : statusPlus && statusPlus === "T&C,Doc" ? false : statusPlus && statusPlus === "Manual,T&C,Doc" ? false : false}
                                                        value="deactivate" control={<Radio color="primary" />}
                                                        label="Temporarily Activate for 7 days" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </RadioGroup>
                                </div>
                            </div>
                        </div>
                        : ""}
                    {props.status == "Active" && isStatusPlusComing === "true" ?
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 p-0">
                            <div className="col-12 border-top w-100 p-0">
                                <div className=' justify-content-around' id="demo-radio-buttons-group-label">
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue="BANK"
                                        name="radio-buttons-group"
                                        onChange={handleChange} value={selected}
                                    >
                                        <div className="row">
                                            <div className={"col"}>
                                                <FormControlLabel className={"col font-size-15 mx-2"}
                                                    value="activate" control={<Radio color="primary" />}
                                                    label="Activate" />
                                            </div>
                                            <Tooltip title="To be used in case of Document issues" placement="top">
                                                <div className={"col"}>
                                                    <FormControlLabel className={"col font-size-15 pr-2"}
                                                        disabled={statusPlus && statusPlus === "Manual" ? true : statusPlus && statusPlus === "T&C" ? true : statusPlus && statusPlus === "Doc" ? false : statusPlus && statusPlus === "Manual,T&C" ? true : statusPlus && statusPlus === "Manual,Doc" ? false : statusPlus && statusPlus === "T&C,Doc" ? false : statusPlus && statusPlus === "Manual,T&C,Doc" ? false : false}
                                                        value="deactivate" control={<Radio color="primary" />}
                                                        label="Temporarily Activate for 7 days" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </RadioGroup>
                                </div>
                            </div>
                        </div>
                        : ""}
                    {
                        props.status == "Active" && isStatusPlusComing === "false" ?
                            <div className="row col-md-12 mb-1 mt-0 px-5">
                                <div className="col-sm-12 col-md-12 px-4 pr-2 mb-0 mt-0">
                                    <div className="col-6">
                                        <TextareaAutosize value={deactivationMessage}
                                            // maxLength={250}
                                            aria-label="minimum height" minRows={6} placeholder="Reason.." className="textArea-correction p-4"
                                            onChange={(e: any) => handleCustomerChange(e)}
                                        />
                                    </div>
                                </div>
                                {deactivationMessageError &&
                                    <span className="col-12 px-5" style={{ color: 'red' }}>Please enter reason for Deactivation.</span>
                                }
                                {deactivateTextErrorMessage &&
                                    <span className="col-12 px-5" style={{ color: 'red' }}>Upto 150 characters are allowed.</span>
                                }
                            </div>
                            : props.message && props.message.length > 0 ? <div className="col-sm-12 col-md-12 px-4 pr-2 mb-0 mt-0">
                                <div className="col-6">
                                    <TextareaAutosize disabled={true} value={deactivationMessage}
                                        // maxLength={250}
                                        aria-label="minimum height" minRows={6} placeholder="Reason.." className="textArea-correction p-4"
                                        onChange={(e: any) => handleCustomerChange(e)}
                                    />
                                </div>
                            </div> : ""}
                </DialogContent>
                <div className="row-space-start col-12 mb-2 mt-0">
                    <div className="col-12 m-0 p-0">
                        <div className="row mb-0 px-2">
                            <div className="col-12 mt-2">
                                <div className="d-flex align-items-center">
                                    <div className="row-space-start ml-auto">
                                        <DialogActions className="mt-3 mb-1 justify-content-end">
                                            <Tooltip title="Please select the radio button." placement="top">
                                                <Button variant="contained"
                                                    color="secondary" className={props.status === "Document expiry issue" && !selected  || props.status == "Active" && isStatusPlusComing === "true" && !selected || props.status == "Deactive" && !selected ? `activate-disabled-button ${submitclassName}` : `${submitclassName}`}
                                                    onClick={() => { validatedeactivateMessage(); }}
                                                    disabled={props.status === "Document expiry issue" && !selected ? true : props.status == "Active" && isStatusPlusComing === "true" && !selected ? true : props.status == "Deactive" && !selected ? true : false}
                                                >{props.status === "Document expiry issue" ? "Yes" : props.status == "Active" && isStatusPlusComing === "true" ? "Yes" : props.status == "Deactive" ? "Yes" : "Submit"}
                                                </Button>
                                            </Tooltip>
                                            <Button variant="contained" className={classes.closeButton}
                                                onClick={() => { props.handleopenClose(false); setdeactivateTextErrorMessage(false); setdeactivationMessageError(false); props.handleopenCloseSnackbar(false); setdeactivationMessage(null); setSelected(null); }}
                                            >{props.status == "Document expiry issue" ? "No" : props.status == "Active" && isStatusPlusComing === "true" ? "No" : props.status == "Deactive" ? "No" : props.status == "Deactive" ? "No" : "Cancel"}
                                            </Button>
                                        </DialogActions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Fragment>
    );
}
